import ChallengesTable from 'components/challenges/ChallengesTable'
import React from 'react'
import PageContent from 'components/common/PageContent'

export default function Challenges(props) {
    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Challenges"}
    ];

    return (
        <PageContent pathElements={pathElements} >
            <ChallengesTable />
        </PageContent>
    );
}